"use client";

import { misc, util } from "@/common/theme";
import { ScrollingText } from "@/components/ScrollingText";
import { Divider, SectionTitle } from "@/components/SectionTitle";
import CustomSplitText from "@/mono/components/CustomSplitText";
import emitter from "@/mono/lib/emitter";
import useEvent from "@/mono/lib/hooks/useEvent";
import { useScrollRigScrollTrigger } from "@/mono/lib/hooks/useScrollRigScrollTrigger";
import { mediaMobile } from "@/mono/lib/responsive";
import { setTypography } from "@/mono/lib/styles/mixins";
import { useRef } from "react";
import styled, { useTheme } from "styled-components";

const FIRST_NUMBER_IN = "FIRST_NUMBER_IN";
function Number({ number, text, dividerStyle, i }) {
  const wrapper = useRef();
  const divider = useRef();

  useScrollRigScrollTrigger({
    el: wrapper,
    handleIn: () => {
      if (i === 0) emitter.emit(FIRST_NUMBER_IN);
      divider.current?.animateIn({ delay: 0.4 });
    },
  });

  return (
    <div className="project-numbers__number" ref={wrapper}>
      <div className="project-numbers__number-inner">
        <CustomSplitText tag="h2">{number}</CustomSplitText>
        <CustomSplitText tag="p">{text}</CustomSplitText>
      </div>
      <Divider
        ref={divider}
        className="project-numbers__divider"
        style={dividerStyle}
      />
    </div>
  );
}

export default function ProjectNumbers({
  data: { titleLeft, titleRight, titleRightSmall, numbers },
}) {
  const dividers = useRef([]);
  const wrapper = useRef();

  const theme = useTheme();

  const dividerStyle = {
    width: "100%",
    background: theme.theme.backgroundAccent,
  };

  useEvent(FIRST_NUMBER_IN, () => {
    dividers.current[0]?.animateIn();
  });

  return (
    <>
      <SectionTitle>It's all about the numbers right?</SectionTitle>
      <Wrapper ref={wrapper}>
        <div className="project-numbers__top">
          <ScrollingText>{titleLeft}</ScrollingText>
          <div className="project-numbers__title-right">
            <CustomSplitText tag="h1">{titleRight}</CustomSplitText>
          </div>
        </div>
        <div>
          <Divider
            ref={(ref) => (dividers.current[0] = ref)}
            style={dividerStyle}
            className="project-numbers__divider"
          />
          {numbers.map(({ number, text }, i) => (
            <Number
              dividerStyle={dividerStyle}
              key={text}
              number={number}
              text={text}
              i={i}
              key={i.toString()}
            />
          ))}
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  ${util.inner}

  .project-numbers__divider {
    background: ${({ theme }) => theme.theme.smallDividerColor} !important;
  }

  .project-numbers__title-right h1 {
    ${setTypography("floatingTitle")}
    color: ${({ theme }) => theme.theme.floatingTitle};
  }

  .project-numbers__top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 250rem;

    .project-numbers__title-right {
      width: 50%;
    }

    .scrolling-text {
      max-width: 40%;
    }
  }

  .project-numbers__number {
    .project-numbers__number-inner {
      display: flex;

      align-items: center;
      padding: 100rem 0;

      h2 {
        width: calc(${misc.pageHalfWidth} + 5%);

        ${setTypography("projectNumber")}
      }

      p {
      }
    }
  }

  ${mediaMobile(`
    .project-numbers__top {
      flex-direction: column;
      align-items: flex-start;

      .project-numbers__title-right, h1 {
        text-align: right;
        width: 100%;
        margin-top: 40rem;
      }

      .scrolling-text {
        max-width: 100%;
        margin-bottom: 50rem;
      }
    }

    .project-numbers__number-inner {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      gap: 40rem;

      h2, p {
        width: 100% !important;
      }
      
      
    }
  `)}
`;
